import React from "react";
import SidebarComponent from "../sideMenu";
import HeaderComponent from "../navigationBar";

const DeliveriesComponent = () => {
    return (
        <>
            <HeaderComponent/>
            <SidebarComponent/>
            Deliveries Component
        </>
    )
}

export default DeliveriesComponent;